import { createCreatorProductStore } from '@services/MarppleShopStudio/widget/CreatorProduct/core/store/createStore.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { BaseSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/BaseSection.ts';
import { html, View } from 'rune-ts';
import { formKeyMap } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { Input_TextEditor } from '@services/MarppleShopStudio/shared/component/atom/Input/Input_TextEditor.ts';
import { Tooltip } from '@services/MarppleShop/renderApp/components/atoms/Tooltip/Tooltip.ts';
import common_klass from './styles/common.module.scss';
import { font } from '@services/MarppleShop/shared/typography';

interface DetailInfoSectionData<T extends MODE> {
  store: ReturnType<typeof createCreatorProductStore<T>>;
}

export class DetailInfoSection<T extends MODE> extends BaseSection<T, DetailInfoSectionData<T>> {
  private store = this.data.store;
  protected readonly sectionTitle = '상세 정보';

  private inputMap = {
    [formKeyMap.product_basic_info]: new Input_TextEditor({
      name: formKeyMap.product_name,
      value: this.store.formData._.product.name ?? '',
      title: html`
        <div class="${common_klass.title_with_tooltip}">
          <span class="${common_klass.text} ${font('14_bold')}">상품명</span>
          ${new Tooltip({
            id: formKeyMap.product_name,
            content: html`
              <div class="${common_klass.tooltip_content_container} ${font('14_medium')}">
                <div class="${common_klass.tooltip_content_divider}">
                  <span>·</span>
                  <span
                    >판매자가 상품 정보(원산지, 제조일, A/S 책임자 등)를 사전에 제공토록 하는 통신판매업자
                    의무 규정</span
                  >
                </div>
                <div class="${common_klass.tooltip_content_divider}">
                  <span>·</span>
                  <span>상품 상세 설명에 해당 정보가 기재되어 있다면 ‘상품 상세 참고'로 기재해 주세요.</span>
                </div>
                <div class="${common_klass.tooltip_content_divider}">
                  <span>·</span>
                  <span>품목에 따른 상품 기재 정보를 모르는 경우, 관련 정부 고시 내용을 참고해 주세요.</span>
                </div>
                <div class="${common_klass.tooltip_content_divider}">
                  <span>&nbsp;</span>
                  <a
                    class="${common_klass.atag}"
                    href="https://www.law.go.kr/%ED%96%89%EC%A0%95%EA%B7%9C%EC%B9%99/%EC%A0%84%EC%9E%90%EC%83%81%EA%B1%B0%EB%9E%98%EB%93%B1%EC%97%90%EC%84%9C%EC%9D%98%EC%83%81%ED%92%88%EB%93%B1%EC%9D%98%EC%A0%95%EB%B3%B4%EC%A0%9C%EA%B3%B5%EC%97%90%EA%B4%80%ED%95%9C%EA%B3%A0%EC%8B%9C"
                    target="_blank"
                    >전자상거래 등에서의 상품 등의 정보 제공에 관한 고시</a
                  >
                </div>
              </div>
            `,
            size: 'x_small',
            variant: 'studio',
          })}
        </div>
      `,
      option: {
        placeholder: '상품정보제공고시 정보에 대한 내용을 입력해 주세요.',
        min_rows: 2,
        max_rows: 15,
      },
    }),
  };

  protected override inputViews(): Array<View> {
    return [this.inputMap.product_basic_info];
  }
}
